import axios from "axios";
import { lang, tr } from "../i18n";
const http = axios.create({ baseURL: "" });
http.interceptors.request.use((config) => {
    const t = localStorage.getItem("token");
    if (t)
        config.headers.Authorization = `Bearer ${t}`;
    // 后端按这个头返回对应语言的提示 / 打印件 / 导出(app/i18n)
    config.headers["Accept-Language"] = lang.value === "en" ? "en" : "zh-CN";
    return config;
});
/**
 * FastAPI 422 的 detail 是 pydantic 错误数组 · 400/401 是字符串 · 5xx 可能什么都没有。
 * 各 view 自己拼 `e?.response?.data?.detail || e?.message` 时,数组会渲染成
 * "红 X 空气泡"(ElMessage 拿到 array 显示不出) —— 在拦截器里把 detail 标准化成
 * 人话字符串,同时挂到 err.message 让 view 的 fallback 兜底也能命中。
 */
function formatDetail(detail) {
    if (Array.isArray(detail)) {
        return detail.map((x) => {
            const loc = (x?.loc || []).slice(1).join(".") || tr("字段");
            return `${loc}: ${x?.msg || tr("错误")}`;
        }).join(" · ");
    }
    if (typeof detail === "string")
        return detail;
    return "";
}
http.interceptors.response.use((r) => r.data?.data ?? r.data, (err) => {
    if (err?.response?.status === 401) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        if (!location.pathname.endsWith("/login") && !location.pathname.endsWith("/platform-login")) {
            location.href = "/login";
        }
    }
    // 把 pydantic 数组 detail 展平成字符串
    const nice = formatDetail(err?.response?.data?.detail);
    if (nice) {
        // 覆盖 detail 供老代码 `e?.response?.data?.detail` 直接用
        if (err?.response?.data)
            err.response.data.detail = nice;
        // 覆盖 message 供 `e?.message` fallback 用
        err.message = nice;
    }
    return Promise.reject(err);
});
export default http;
//# sourceMappingURL=http.js.map